import { api } from './client';

// ── Addon groups ─────────────────────────────────────────────────────────────
// Contrato confirmado pelo backend: grupo é vinculado a produto(s) via
// `productIds` e referencia adicionais já existentes via `addonIds` — quem
// cria/edita o adicional em si continua sendo o formulário do produto/categoria.

export function listAddonGroups() {
  return api.get('/establishments/me/addon-groups');
}

export function createAddonGroup(data) {
  return api.post('/establishments/me/addon-groups', data);
}

export function updateAddonGroup(groupId, data) {
  return api.patch(`/establishments/me/addon-groups/${groupId}`, data);
}

export function deleteAddonGroup(groupId) {
  return api.delete(`/establishments/me/addon-groups/${groupId}`);
}
